// extracted by mini-css-extract-plugin
module.exports = {"iconArrow":"styles_iconArrow__3kVqS","none":"styles_none__30QJ9","wrap":"styles_wrap__1IoEO"};